import api from '@/api'

const getMe = function () {
  return api.get('/user')
}

export default {
  getMe,
}
